export default {
  tags: {
    preferred: 'Foretrukket',
  },
};
